<template>
    <div class="footer-content">
        <div class="content">
            <div class="pages">
                <div class="page" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                    {{ btn.name }}
                </div>
            </div>
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                PLUSGOLD WORLDWIDE COMPANY LIMITED
            </div>
            <div class="item-box">
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2026 Copyright belongs to PLUSGOLD WORLDWIDE COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.replace(path);
};
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/service",
    },
    {
        name: "บริการ",
        path: "/about",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
];
const list = [
    {
        content: "office@plusgoldworld.com",
        index: 1,
    },
    {
        content: "444/28 หมู่ที่ 6 ตำบลสุรนารี อำเภอเมืองนครราชสีมา จ.นครราชสีมา 30000",
        index: 2,
    },
    {
        content: "+66 0925710427",
        index: 3,
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 300px;
    background: #2B2929;
    padding: 0 270px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding: 38px 0;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .pages {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-bottom: 30px;

            .page {
                font-weight: 400;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 14px;
                cursor: pointer;
            }
        }

        .title {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
            margin-bottom: 39px;

            img {
                width: 60px;
                height: 60px;
                object-fit: contain;
                border-radius: 8px 8px 8px 8px;
                margin-right: 17px;
            }
        }

        .item-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item {
                max-width: 415px;
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                line-height: 20px;
                text-shadow: 0px 1px 0px #333333;

                img {
                    width: 15px;
                    object-fit: cover;
                    margin-right: 5px;
                }
            }
        }
    }

    .bottom {
        margin-top: 14px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>